export default __webpack_public_path__ + "static/presentacionVirtualc-69cd6b9cc1491db287daae316522ce66.jpg";